/**
 * Vertical gap between a slide's title text and the markdown content
 * container that follows it. Shared by cover and divider slides so the
 * two layouts stay visually aligned.
 */
export const SLIDE_TITLE_TO_CONTENT_SPACING = '3vh';

/**
 * MUI spacing multiplier for the reserved space at the top of cover
 * and divider slides before the header (logo + title) begins. Shared
 * so the two layouts start at the same vertical position. Use as
 * `theme.spacing(SLIDE_CONTENT_TOP_OFFSET_SPACING)`.
 *
 * Resolves to 204px under MUI's default 8px spacing scale. Use this
 * for slide-editor layouts whose title sizing is driven by
 * `TITLE_TEXT_SIZE_CONFIG` — titles there default to Medium (36/48),
 * unchanged across the Romie refresh, so the legacy 204px reservation
 * still lands the body content in the right place.
 */
export const SLIDE_CONTENT_TOP_OFFSET_SPACING = 25.5;

/**
 * MUI spacing multiplier for cover slides whose title comes directly
 * from the `h1_display` variant (now Romie xxl 48/62 under
 * PresentationTypographyProvider). Trimmed by ~26px from
 * `SLIDE_CONTENT_TOP_OFFSET_SPACING` to absorb the variant's taller
 * line-box and keep body content at the same vertical position as
 * before the Romie swap. Use as
 * `theme.spacing(SLIDE_HERO_CONTENT_TOP_OFFSET_SPACING)`.
 *
 * Resolves to 178px under MUI's default 8px spacing scale.
 */
export const SLIDE_HERO_CONTENT_TOP_OFFSET_SPACING = 22.25;
